if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.variantSelects = this.querySelector('variant-radios');
        this.submitButton = this.querySelector('[type="submit"]');
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) current.setAttribute(attribute, valueUpdated);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}

(function () {
  function getDirectChildOfProductInfo(root, element) {
    while (element && element.parentElement !== root) {
      element = element.parentElement;
    }
    return element;
  }

  function moveSizeChartAboveInventory() {
    document.querySelectorAll('product-info[id^="ProductInfo-"]').forEach(function (root) {
      var sizeButton = Array.from(root.querySelectorAll('.product-popup-modal__button')).find(function (button) {
        return button.textContent.trim().toLowerCase().includes('size chart') && !button.closest('fieldset');
      });

      if (!sizeButton) return;

      var sizeBlock =
        sizeButton.closest('modal-opener.product-popup-modal__opener') ||
        getDirectChildOfProductInfo(root, sizeButton);

      if (!sizeBlock) return;

      var inventoryTextElement = Array.from(root.querySelectorAll('*')).find(function (element) {
        var text = element.textContent.trim().toLowerCase();
        return text.includes('almost sold out') || text.includes('ships by');
      });

      if (!inventoryTextElement) return;

      var inventoryBlock = getDirectChildOfProductInfo(root, inventoryTextElement);
      if (!inventoryBlock || inventoryBlock === sizeBlock) return;

      sizeBlock.style.setProperty('display', 'block', 'important');
      sizeBlock.style.setProperty('margin-top', '8px', 'important');
      sizeBlock.style.setProperty('margin-bottom', '8px', 'important');

      sizeButton.style.setProperty('padding', '0', 'important');
      sizeButton.style.setProperty('margin', '0', 'important');
      sizeButton.style.setProperty('display', 'inline-flex', 'important');
      sizeButton.style.setProperty('align-items', 'center', 'important');
      sizeButton.style.setProperty('gap', '6px', 'important');

      root.insertBefore(sizeBlock, inventoryBlock);
    });
  }

  document.addEventListener('DOMContentLoaded', moveSizeChartAboveInventory);
  window.addEventListener('load', moveSizeChartAboveInventory);
  document.addEventListener('shopify:section:load', moveSizeChartAboveInventory);

  setTimeout(moveSizeChartAboveInventory, 300);
  setTimeout(moveSizeChartAboveInventory, 1000);
  setTimeout(moveSizeChartAboveInventory, 2000);

  new MutationObserver(function () {
    setTimeout(moveSizeChartAboveInventory, 50);
  }).observe(document.body, {
    childList: true,
    subtree: true
  });
})();
